/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const PolicyActionsRoutes: Routes = [
  {
    path: RoutePaths.MODIFY_POLICY.route,
    loadChildren: () => import('@pages/policy-actions/policy-actions.module').then(m => m.PolicyActionsPageModule),
    canActivate: [NavigationGuard],
  },
];
